export default __webpack_public_path__ + "static/media/watch.a70f85a9.svg";